import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Post } from "../types/post";

const PostForm: React.FC<{
  initialValues: Post;
  onSubmit: (values: Post, { resetForm }: { resetForm: () => void }) => void;
}> = ({ initialValues, onSubmit }) => {
  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
    imageUrl: Yup.string().url("Invalid URL").required("Image URL is required"),
    readTime: Yup.number().min(0, "Read time must be positive"),
    publishedDate: Yup.string().nullable(),
    author: Yup.string().required("Author is required"),
    authorImage: Yup.string()
      .url("Invalid URL")
      .required("Author image URL is required"),
    redirectLink: Yup.string()
      .url("Invalid URL")
      .required("Redirect link is required"),
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <Form className="space-y-4">
        <div>
          <label htmlFor="title" className="block mb-1">
            Title:
          </label>
          <Field
            type="text"
            id="title"
            name="title"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <ErrorMessage
            name="title"
            component="div"
            className="text-red-500 text-sm mt-1"
          />
        </div>
        <div>
          <label htmlFor="description" className="block mb-1">
            Description:
          </label>
          <Field
            type="text"
            id="description"
            name="description"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <ErrorMessage
            name="description"
            component="div"
            className="text-red-500 text-sm mt-1"
          />
        </div>
        <div>
          <label htmlFor="redirectLink" className="block mb-1">
            Redirect Link:
          </label>
          <Field
            type="text"
            id="redirectLink"
            name="redirectLink"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <ErrorMessage
            name="redirectLink"
            component="div"
            className="text-red-500 text-sm mt-1"
          />
        </div>
        <div>
          <label htmlFor="imageUrl" className="block mb-1">
            Image URL:
          </label>
          <Field
            type="text"
            id="imageUrl"
            name="imageUrl"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <ErrorMessage
            name="imageUrl"
            component="div"
            className="text-red-500 text-sm mt-1"
          />
        </div>
        <div>
          <label htmlFor="readTime" className="block mb-1">
            Read Time:
          </label>
          <Field
            type="number"
            id="readTime"
            name="readTime"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <ErrorMessage
            name="readTime"
            component="div"
            className="text-red-500 text-sm mt-1"
          />
        </div>
        <div>
          <label htmlFor="publishedDate" className="block mb-1">
            Published Date:
          </label>
          <Field
            type="text"
            id="publishedDate"
            name="publishedDate"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <ErrorMessage
            name="publishedDate"
            component="div"
            className="text-red-500 text-sm mt-1"
          />
        </div>
        <div>
          <label htmlFor="author" className="block mb-1">
            Author:
          </label>
          <Field
            type="text"
            id="author"
            name="author"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <ErrorMessage
            name="author"
            component="div"
            className="text-red-500 text-sm mt-1"
          />
        </div>
        <div>
          <label htmlFor="authorImage" className="block mb-1">
            Author Image URL:
          </label>
          <Field
            type="text"
            id="authorImage"
            name="authorImage"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <ErrorMessage
            name="authorImage"
            component="div"
            className="text-red-500 text-sm mt-1"
          />
        </div>

        <button
          type="submit"
          className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
        >
          Submit
        </button>
      </Form>
    </Formik>
  );
};

export default PostForm;
